var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDissatisfied(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5488 35C27.2138 35 35.0488 27.165 35.0488 17.5C35.0488 7.83502 27.2138 0 17.5488 0C7.88384 0 0.0488281 7.83502 0.0488281 17.5C0.0488281 27.165 7.88384 35 17.5488 35Z",
    fill: "url(#paint0_radial_321_22)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.5488 35C27.2138 35 35.0488 27.165 35.0488 17.5C35.0488 7.83502 27.2138 0 17.5488 0C7.88384 0 0.0488281 7.83502 0.0488281 17.5C0.0488281 27.165 7.88384 35 17.5488 35Z",
    fill: "url(#paint1_radial_321_22)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7642 9.17684C13.7205 8.33465 12.933 7.85341 11.6314 7.91903C10.5267 7.98466 8.13143 8.84872 6.60019 11.5175C6.31581 12.0097 6.808 12.2503 7.09237 11.9222C8.06581 10.8175 10.7455 9.31903 12.9111 9.4831C13.7861 9.54872 13.7642 9.17684 13.7642 9.17684Z",
    fill: "url(#paint2_linear_321_22)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8396 18.2551C12.7699 18.2551 13.524 17.1141 13.524 15.7066C13.524 14.2992 12.7699 13.1582 11.8396 13.1582C10.9094 13.1582 10.1553 14.2992 10.1553 15.7066C10.1553 17.1141 10.9094 18.2551 11.8396 18.2551Z",
    fill: "url(#paint3_radial_321_22)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8396 14.0223C12.5615 14.0223 13.1959 14.6566 13.524 15.5863C13.5021 14.2082 12.7584 13.1035 11.8396 13.1035C10.9209 13.1035 10.1771 14.2082 10.1553 15.5863C10.4834 14.6457 11.1068 14.0223 11.8396 14.0223Z",
    fill: "url(#paint4_linear_321_22)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2586 18.2551C24.1888 18.2551 24.943 17.1141 24.943 15.7066C24.943 14.2992 24.1888 13.1582 23.2586 13.1582C22.3283 13.1582 21.5742 14.2992 21.5742 15.7066C21.5742 17.1141 22.3283 18.2551 23.2586 18.2551Z",
    fill: "url(#paint5_radial_321_22)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3331 9.23153C21.3768 8.38934 22.1643 7.9081 23.4659 7.97372C24.5706 8.03935 26.9659 8.90341 28.4971 11.5722C28.7815 12.0643 28.2893 12.305 28.0049 11.9768C27.0315 10.8722 24.3518 9.37372 22.1862 9.53778C21.3112 9.61435 21.3331 9.23153 21.3331 9.23153Z",
    fill: "url(#paint6_linear_321_22)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2586 14.077C22.5367 14.077 21.9023 14.7113 21.5742 15.641C21.5961 14.2629 22.3398 13.1582 23.2586 13.1582C24.1773 13.1582 24.9211 14.2629 24.943 15.641C24.6148 14.7113 23.9914 14.077 23.2586 14.077Z",
    fill: "url(#paint7_linear_321_22)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2706 27.5623C25.6096 27.2889 25.6753 26.7857 25.4128 26.4357C23.8706 24.3576 21.4096 22.4873 17.5487 22.4873C13.6878 22.4873 11.2268 24.3576 9.68462 26.4357C9.42212 26.7857 9.48775 27.2889 9.82682 27.5623C10.1878 27.8576 10.7346 27.792 11.0081 27.4092C12.3315 25.6592 14.3549 24.1936 17.5378 24.1936C20.7206 24.1936 22.7549 25.6592 24.0674 27.4092C24.3628 27.792 24.8987 27.8576 25.2706 27.5623Z",
    fill: "url(#paint8_radial_321_22)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5661 27.0154C25.588 26.8186 25.5443 26.6107 25.413 26.4357C23.8708 24.3576 21.4099 22.4873 17.5489 22.4873C13.688 22.4873 11.227 24.3576 9.68486 26.4357C9.55361 26.6107 9.50986 26.8186 9.53174 27.0154C11.2052 24.9811 13.7427 23.2639 17.5489 23.2639C21.3552 23.2639 23.9036 24.9811 25.5661 27.0154Z",
    fill: "url(#paint9_linear_321_22)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_321_22",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.1057 10.4114) scale(21.1115)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB92E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_321_22",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.1057 10.4114) scale(16.6093)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC47",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_321_22",
    x1: 10.1585,
    y1: 10.776,
    x2: 10.0368,
    y2: 8.56707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_321_22",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.3259 15.7701) rotate(73.8539) scale(2.47262 1.59975)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_321_22",
    x1: 11.8355,
    y1: 13.141,
    x2: 11.8355,
    y2: 15.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_321_22",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7537 15.7705) rotate(73.854) scale(2.47262 1.59974)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_321_22",
    x1: 24.9492,
    y1: 10.839,
    x2: 25.0709,
    y2: 8.63011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_321_22",
    x1: 23.2628,
    y1: 13.2035,
    x2: 23.2628,
    y2: 15.5785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_321_22",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.0539 22.8354) scale(6.79939 7.66905)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_321_22",
    x1: 9.52134,
    y1: 24.7511,
    x2: 25.5765,
    y2: 24.7511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDissatisfied);
export default __webpack_public_path__ + "static/media/Dissatisfied.7c72b35491841c1764e77065cca48f27.svg";
export { ForwardRef as ReactComponent };